<template>
  <div>
    <div
      class="noto bold pa-3 d-md-flex align-center" width="100%">
      <div class="title primary--text">Menú</div>
      <v-spacer/>
      <v-btn
        rounded
        small
        depressed
        color="primary"
        class="mr-3"
        @click="export2pdf">
        Exportar como PDF
      </v-btn>
      <v-btn
        rounded
        small
        depressed
        color="primary"
        class="white--text mr-3"
        @click="export2csv"
        >
        Exportar menu como CSV
      </v-btn>
      <v-btn
        v-if="restaurant.picture"
        rounded
        small
        depressed
        color="primary"
        @click="download">
        Descargar logo
      </v-btn>
    </div>

    <div class="px-3 pt-3 pb-3">
      <v-skeleton-loader v-if="overlay" type="button" />
      <v-btn-toggle
        v-else
        v-model="favorites"
        rounded
        mandatory>
        <v-btn
          small
          class="white--text"
          :outlined="favorites !== 0"
          color="primary">
          Todos
        </v-btn>
        <v-btn
          class="white--text"
          small
          :outlined="favorites !== 1"
          color="primary">
          Favoritos
        </v-btn>
      </v-btn-toggle>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :loading="table.loading"
        :server-items-length="table.total"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :footer-props="{
          'items-per-page-options': [10, 20, 30, 40, 50]
        }"
        :items-per-page="50"
        sort-by="name"
        item-key="_id"
        v-model="table.selected"
        @update:options="updateTable"
        class="elevation-1 fixed-header">
        <template v-slot:top>
          <div class="px-3 filters">
            <v-row>
              <v-col md="2">
                <div class="d-flex align-end">
                  <span>
                    Recetario faltante: {{ remainingRecipes | toFixNumber }}%
                  </span>
                </div>
              </v-col>
              <v-col md="2">
                <div class="d-flex align-end">
                  <span>
                    Avance: {{ doneRecipes | toFixNumber }}%
                  </span>
                </div>
              </v-col>
              <v-col md="2">
                <v-select
                  :value="statusSelected"
                  :items="statuses"
                  item-value="key"
                  item-text="name"
                  label="Estado"
                  clearable
                  hide-details
                  return-object
                  dense
                  no-data-text="No encontramos ninguna estado"
                  @change="filterByStatus"
                  @click:clear="statusSelected = {}"
                />
              </v-col>
              <v-col md="2">
                <v-select
                  multiple
                  :value="sectionSelected"
                  :items="sections"
                  item-value="id"
                  item-text="name"
                  label="Sección"
                  clearable
                  hide-details
                  dense
                  no-data-text="No encontramos ninguna sección, puedes crearla en el apartado de ajustes → secciones"
                  @change="filterBySection"
                  @click:clear="sectionSelected = []"
                />
              </v-col>
              <v-col cols="4">
                <v-text-field
                  append-icon="mdi-magnify"
                  label="Buscar recetas en el menú."
                  solo
                  rounded
                  hide-details
                  flat
                  dense
                  v-model="search"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.favorite="{ item }">
          <div v-if="overlay">
            <v-progress-circular color="primary" indeterminate />
          </div>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on }">
              <v-icon
                :color="item.menu ? 'warning' : 'grey'"
                v-on="on"
                @click="markInMenu(item)">
                {{ item.menu ? 'mdi-star' : 'mdi-star-outline' }}
              </v-icon>
            </template>
            <span>
              {{ item.menu ? 'Desmarcar platillo' : 'Marcar platillo como en carta' }}
            </span>
          </v-tooltip>
        </template>
        <template v-slot:item.name="{ item }">
          <div>
            <a v-if="item.merged === false && item.createdBySalePoint === true && recipeBookPermissions['update-menu']"
              href="" @click.prevent="openMatchRecipesDialog(item)">
              {{ item.name }}
            </a>
            <span v-else>
              {{ item.name }}
            </span>
          </div>
          <div class="caption grey--text">
            <span v-if="item.internalId">
              {{ item.internalId }}
            </span>
            <span v-else>
              -
            </span>
          </div>
        </template>
        <template v-slot:item.section="{ item }">
          <span v-if="item.section">
            {{ item.section.name }}
          </span>
          <span v-else>
            -
          </span>
        </template>
        <template v-slot:item.price="{ item }">
          <span v-if="item.price >= 0">
            ${{ item.price | toFix2 | numberWithComma }}
          </span>
          <span v-else>
            -
          </span>
          <div class="caption grey--text">
            <span>
              {{ item.cost | percentOf(item.price) | toFixNumber }}%
            </span>
          </div>
        </template>
        <template v-slot:item.wPrice="{ item }">
            <template v-if="!item.wPrice">
              <a href="#" class="small" @click="openEditPriceModal(item)" v-if="recipeBookPermissions['update-menu']">
                <span >$0.00</span>
              </a>
              <span v-else>$0.00</span>
            </template>
            <template v-else>
              <a href="#" class="small" @click="openEditPriceModal(item)" v-if="recipeBookPermissions['update-menu']">
                <span>${{ item.wPrice | toFix2 | numberWithComma }}</span>
              </a>
              <span v-else>${{ item.wPrice | toFix2 | numberWithComma }}</span>
            </template>
            <div class="caption grey--text">
            <span>
              {{ item.cost | percentOf(item.wPrice) | toFixNumber }}%
            </span>
          </div>
        </template>
        <template v-slot:item.status="{ item }">
          <div>
            <a href="" @click.prevent="openChangeStatusRecipe(item)">
              {{ statusRecipe(item) }}
            </a>
            <div class="caption grey--text">
              {{ statusDescription(item) }}
            </div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex align-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                  x-small
                  fab
                  depressed
                  v-on="on"
                  class="mr-1"
                  color="accent"
                >
                  <v-icon size="14">
                    mdi-dots-vertical
                  </v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="openIngredientsDialog(item)">
                  <v-list-item-icon>
                    <v-icon color="#78909C"> mdi-eye </v-icon>
                  </v-list-item-icon>
                    <v-list-item-title> Ver receta </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <template v-slot:item.monthSale="{ item }">
          <div v-if="item.monthSale">
            <span> {{ item.monthQty }} </span>
          </div>
          <span v-if="item.monthSale" class="caption grey--text">
            $ {{ item.monthSale | toFix2 | numberWithComma }}
          </span>
          <span v-else>-</span>
        </template>
      </v-data-table>
    </v-flex>

    <EditPrice
      :item="selectedRecipe"
      ref="editPriceModal"
      @submit="load()"
    />

    <MatchRecipesWantsoft
      :item="selectedRecipe"
      :btn="false"
      ref="matchRecipesDialog"
      @submit="load()"
    />

    <ChangeStatusRecipe
      :item="selectedRecipe"
      ref="changeStatusRecipe"
      @submit="load()"
    />

    <IngredientsDialog
      :recipe="selectedRecipe"
      :ingredientDialog="ingredientDialog"
      @closeIngredientDialog="closeIngredientDialog"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import JsPdf from 'jspdf'
import Papa from 'papaparse'
import Section from '@/models/Section'
import 'jspdf-autotable'
import MatchRecipesWantsoft from '@/components/modals/MatchRecipesWantsoft'
import ChangeStatusRecipe from '@/components/modals/ChangeStatusRecipe'
import IngredientsDialog from '@/components/sidePanels/RecipeDetail'
import EditPrice from '@/components/modals/EditPrice'
import { cloneDeep, debounce } from 'lodash'

export default {
  name: 'Menu',
  components: {
    MatchRecipesWantsoft,
    ChangeStatusRecipe,
    IngredientsDialog,
    EditPrice
  },
  data () {
    let section = new Section()
    return {
      editPriceModal: null,
      sectionModel: section,
      sectionsList: [],
      isLoading: false,
      ingredientDialog: false,
      table: {
        title: this.$i18n.t('recipes.loading'),
        loading: true,
        headers: [
          { value: 'favorite', sortable: false },
          { text: this.$i18n.t('recipes.headers.name'), value: 'name' },
          { text: this.$i18n.t('recipes.headers.section'), value: 'section', sortable: false },
          { text: this.$i18n.t('recipes.headers.price'), value: 'price', sortable: false, align: 'center' },
          { text: this.$i18n.t('recipes.headers.wPrice'), value: 'wPrice', sortable: false, align: 'center' },
          { text: this.$i18n.t('recipes.headers.status'), value: 'status', sortable: false },
          { text: this.$i18n.t('recipes.headers.monthSale'), value: 'monthSale', sortable: false },
          { text: this.$i18n.t('recipes.headers.actions'), value: 'action', sortable: false }
        ],
        data: [],
        total: 0,
        remainingRecipes: 0,
        selected: [],
        options: {
          groupBy: [],
          groupDesc: [],
          multiSort: false,
          mustSort: false,
          sortBy: ['name'],
          sortDesc: [false],
          itemsPerPage: 50,
          page: 1
        }
      },
      overlay: false,
      selectedRecipe: {},
      search: '',
      sectionSelected: [],
      favorites: 0,
      statusSelected: {},
      statuses: [
        { key: 'withoutRecipe', name: 'En menú sin receta' },
        { key: 'connect', name: 'Conectada' }
      ]
    }
  },
  computed: {
    restaurant: function () {
      return this.$store.state.currentRestaurant.data
    },
    areaId () {
      return this.$store.state.area._id
    },
    remainingRecipes () {
      const totalRecipes = this.table.remainingRecipes + this.table.total
      return (this.table.remainingRecipes / totalRecipes) * 100
    },
    doneRecipes () {
      return 100 - this.remainingRecipes
    },
    sections: function () {
      return (this.$store.state.currentRestaurant.sections.data || [])
        .filter(section => section.area && (section.area === this.$store.state.area._id || section.area._id === this.$store.state.area._id))
    },
    recipeBookPermissions () {
      return this.$store.state.login.permissions['recipe-book'].components['menu'].actions
    }
  },
  watch: {
    '$store.state.area': async function (val) {
      await this.load()
    },
    'search': debounce(async function (val) {
      if (val.length >= 3) {
        this.table.loading = true
        try {
          const params = {
            skip: 0,
            name: `/${val}/i`
          }
          if (this.sectionSelected) params.section = this.sectionSelected.join()
          const response = await this.$api.get(`/v1/menu/${this.areaId}`, params)
          this.table.data = response.data
          this.table.total = response.total
          this.table.remainingRecipes = response.remainingRecipes
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        await this.load()
      }
      this.table.loading = false
    }, 300),
    favorites: async function () {
      await this.load()
    }
  },
  async mounted () {
    await this.load()
  },
  methods: {
    markInMenu: async function (item) {
      this.overlay = true
      const payload = { menu: !item.menu }
      try {
        await this.$api.put(`/v1/menu/${item._id}`, payload)
        await this.load()
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.overlay = false
    },
    openEditPriceModal (item) {
      this.$refs.editPriceModal.$props.item = item
      this.$refs.editPriceModal.open()
    },
    openIngredientsDialog (item) {
      this.selectedRecipe = item
      this.ingredientDialog = true
    },
    closeIngredientDialog () {
      this.ingredientDialog = false
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: this.table.options.sortBy[0] ? `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}` : 'name'
      }
      this.overlay = true
      this.table.loading = true
      try {
        if (this.sectionSelected) params.section = this.sectionSelected.join()
        if (this.statusSelected) params.status = this.statusSelected.key
        if (this.search) params.name = `/${this.search}/i`
        if (this.favorites === 1) params.menu = true
        const response = await this.$api.get(`/v1/menu/${this.areaId}`, params)
        this.table.data = response.data
        this.table.total = response.total
        this.table.remainingRecipes = response.remainingRecipes
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
      this.overlay = false
      this.table.loading = false
    },
    export2pdf: async function () {
      try {
        const pdf = new JsPdf()

        const percentOf = (value, total) => {
          return (value && total && total !== 0) ? ((value / total) * 100).toFixed(2) : '0'
        }

        pdf.text(`${this.restaurant.name} `, 15, 10)

        const filteredHeaders = [
          { text: 'Platillo', value: 'name', sortable: false },
          { text: 'Precio de venta', value: 'price', sortable: false },
          { text: '% costo actual', value: 'costPercentage', sortable: false },
          { text: 'Precio sugerido', value: 'wPrice', sortable: false },
          { text: '% costo sugerido', value: 'wCostPercentage', sortable: false }
        ]

        let filteredData = []

        if (this.search || this.sectionSelected) {
          const response = await this.$api.get(`/v1/menu/${this.areaId}`, {
            name: this.search ? `/${this.search}/i` : null,
            section: this.sectionSelected.length ? this.sectionSelected.join() : null,
            limit: 0
          })
          filteredData = response.data
        } else {
          const allRecipesResponse = await this.$api.get(`/v1/menu/${this.areaId}`, { limit: 0 })
          filteredData = allRecipesResponse.data
        }

        const formattedData = filteredData.map(item => {
          const formattedItem = filteredHeaders.map(header => {
            if (header.value === 'price' || header.value === 'wPrice') {
              const priceValue = typeof item[header.value] === 'number' ? item[header.value] : 0
              return `$${priceValue.toFixed(2).replace(',', '.')}`
            } else if (header.value === 'costPercentage') {
              return `${percentOf(item.cost, item.price)}%`
            } else if (header.value === 'wCostPercentage') {
              return `${percentOf(item.cost, item.wPrice)}%`
            } else {
              return item[header.value]
            }
          })

          return formattedItem
        })

        const tableData = formattedData
        const tableOptions = {
          startY: 40,
          head: [filteredHeaders.map(header => header.text)],
          headStyles: {
            fillColor: [1, 210, 142],
            textColor: [50, 50, 50],
            fontSize: 8
          },
          styles: { fontSize: 8 }
        }

        pdf.autoTable({
          head: tableOptions.head,
          body: tableData,
          headStyles: tableOptions.headStyles,
          styles: tableOptions.styles
        })

        pdf.save(`menu-${this.restaurant.name}.pdf`)
        this.$toasted.show('Exportación PDF exitosa', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
    },
    export2csv: async function () {
      try {
        const percentOf = (value, total) => {
          return (value && total && total !== 0) ? ((value / total) * 100).toFixed(2) : '0'
        }

        const allRecipesResponse = await this.$api.get(`/v1/menu/${this.areaId}`, {
          name: this.search ? `/${this.search}/i` : null,
          section: this.sectionSelected.length ? this.sectionSelected.join() : null,
          limit: 0
        })

        const allRecipesData = allRecipesResponse.data

        const csvData = allRecipesData.map(item => {
          const costPercentage = percentOf(item.cost, item.price)
          const wCostPercentage = percentOf(item.cost, item.wPrice)

          return {
            'Platillo': item && item.name ? item.name : '',
            'Sección': item.section && item.section.name ? item.section.name : '',
            'Precio de venta': `$${item.price}`,
            '% costo actual': `${costPercentage}%`,
            'Precio sugerido': `$${item.wPrice !== undefined ? item.wPrice : 0}`,
            '% costo sugerido': `${wCostPercentage}%`
          }
        })

        const csv = Papa.unparse(csvData)

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
        const link = document.createElement('a')
        if (link.download !== undefined) {
          const url = URL.createObjectURL(blob)
          link.setAttribute('href', url)
          link.setAttribute('download', `menu-${this.restaurant.name}.csv`)
          link.style.visibility = 'hidden'
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          this.$toasted.show('Exportación CSV exitosa', { duration: 3500, type: 'success', position: 'top-center', iconPack: 'mdi', icon: 'mdi-check-circle' })
        } else {
          this.$toasted.show('Exportación CSV no es compatible en este navegador.', { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
        }
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3500, type: 'error', position: 'top-center', iconPack: 'mdi', icon: 'mdi-cancel' })
      }
    },
    getDataUrl: async function () {
      const url = this.restaurant.picture.location
      const resp = await fetch(url, {
        mode: 'cors',
        headers: {
          'Access-Control-Allow-Origin': '*'
        }
      })
      const blob = await resp.blob()
      return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(blob)
        reader.onerror = reject
        reader.onloadend = () => resolve(reader.result)
      })
    },
    download () {
      const link = document.createElement('a')
      link.href = this.restaurant.picture.location
      link.download = this.restaurant.name
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    updateTable: async function (data) {
      this.table.options = data
      const params = {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: this.table.options.sortBy[0] ? `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}` : 'name'
      }
      try {
        await this.load(params)
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
    },
    openMatchRecipesDialog (item) {
      const recipe = cloneDeep(item)
      this.selectedRecipe = recipe
      this.$refs.matchRecipesDialog.open()
    },
    openChangeStatusRecipe (item) {
      const recipe = cloneDeep(item)
      this.selectedRecipe = recipe
      this.$refs.changeStatusRecipe.open()
    },
    statusRecipe (item) {
      const merge = !!item.merged
      const createdBySalePoint = !!item.createdBySalePoint
      let result = ''
      if (merge && createdBySalePoint) result = 'Conectada'
      if (merge === false && createdBySalePoint === false) result = 'Conectada'
      if (merge && createdBySalePoint === false) result = 'Conectada'
      if (merge === false && createdBySalePoint) result = 'En menú sin receta'
      if ((merge === false && createdBySalePoint) && item.ingredients.length > 0) result = 'Conectada'
      return result
    },
    statusDescription (item) {
      const merge = !!item.merged
      const createdBySalePoint = !!item.createdBySalePoint
      let result = ''
      if (merge && createdBySalePoint) result = 'con receta'
      if (merge === false && createdBySalePoint === false) result = 'con receta'
      if (merge && createdBySalePoint === false) result = 'con receta'
      if (merge === false && createdBySalePoint) result = 'En menú sin receta'
      if ((merge === false && createdBySalePoint) && item.ingredients.length > 0) result = 'con receta'
      return result
    },
    filterBySection: debounce(async function (val) {
      this.sectionSelected = val
      await this.load()
    }, 300),
    filterByStatus: debounce(async function (val) {
      this.statusSelected = val
      await this.load()
    }, 300)
  }
}
</script>

<style lang="scss" scoped>
.logo {
  max-width: 150px;
  max-height: 150px;
}
</style>
